/*
 * Description: Display Paragraph Web Component
 * Purpose: Displays styled paragraph text with size and muted options
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Configurable font size (sm, md, lg)
 * - Muted text option
 * - Slot-based content
 *
 * Usage:
 * <display-paragraph size="lg">Large paragraph text.</display-paragraph>
 * <display-paragraph muted size="sm">Small muted text.</display-paragraph>
 * <display-paragraph>Default paragraph text.</display-paragraph>
 *
 * Attributes:
 * - size: String - Font size: 'sm', 'md', 'lg' (default: 'md')
 * - muted: Boolean - Apply muted text styling
 *
 */

class display_paragraph extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const size = this.getAttribute('size') || 'md';
        const muted = this.hasAttribute('muted');
        const content = this.innerHTML;

        const sizeClass = {
            sm: 'fs-6',
            md: '',
            lg: 'fs-5'
        }[size] || '';

        this.innerHTML = `
            <p class="${sizeClass} ${muted ? 'text-muted' : ''}">${content}</p>`;
        this.dataset.rendered = "true";
    }
}

export { display_paragraph };
